let accessKey = ''

export const setAccessKey = (value: string) => {
  accessKey = value
}

export const getAccessKey = () => accessKey
